import React from "react";
import "./TopBar.css";
import { ReactComponent as Logo } from "../../../../Assets/logo.svg";
import Typography from "@mui/material/Typography";
import { FaUserTie } from "react-icons/fa";
import { Navigate, useLocation } from "react-router-dom";
import { Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { MdLogout, MdAddBox } from "react-icons/md";
import { setHeaderMapping } from "../../state/Match/matchSlice";
import { resetUploadStatus } from "../../state/FileUpload/fileUploadSlice";
import { useNavigate } from "react-router";

//components/Match/MatchSlice/matchSlice
const TopBar = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const user = useSelector((state) => state.login.user);
  const { firstName, lastName } = user || {};
  // Authorization is now handled at the route level in ChiesiRoutes
  const handleLogout = () => {
    //dispatch(logout());
    //window.location.href = "/";
   // window.location.reload();
    navigate("/offerings");
  };

  return (
    <>
      <div className="top-bar" >
        <div className="client-details">
          
            {/* <img className="logo" src={logo} alt="Chiesi Logo" /> */}
            <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
            <Logo />
          </Typography>
          <div className="portal-details">
            <div className="portal-name">Customer Matching Portal</div>
            <span className="region-name">AUSTRALIA</span>
          </div>
        </div>
        <div className="user-info">
          <p>
            <span id="user">
              {firstName} {lastName}
            </span>
          </p>
          <FaUserTie />

          <div className="sign-out-button" onClick={handleLogout}>
            <MdLogout />
          </div>
        </div>
      </div>
      <div className="nav-bar">
        <ul className="nav-link-list">
          <li>
            <Link to="/custome-rmatch-portal">Active Jobs</Link>
          </li>
          <li>
            <Link to="/custome-rmatch-portal/completedJobs">Completed Jobs</Link>
          </li>
        </ul>
        <div className="new-job">
          {location.pathname !== "/custome-rmatch-portal/fileUpload" && (
            <Link
              to="/custome-rmatch-portal/fileUpload" 
              onClick={() => {
                dispatch(setHeaderMapping([]));
                dispatch(resetUploadStatus());
              }}
            >
              + New Job
            </Link>
          )}
        </div>
      </div>
    </>
  );
};

export default TopBar;
